import React from 'react';
import { Toaster } from 'sonner';

const Toast = () => {
  return (
    <Toaster
      position="top-right"
      expand={true}
      richColors
      closeButton
    />
  );
};

export default Toast;
